import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Tooltip from '@tippy.js/react'
import { translate } from 'react-polyglot'
import history from 'configureHistory'

import {
	FlexContainer,
	ButtonGroup,
	Button,
	Icon,
	Avatar,
	Search,
	Text,
} from 'components'

class PageHeader extends Component {
	onCreate = tippy => {
		this.tippy = tippy
	}

	closeTippy = () => {
		this.tippy.hide()
	}

	render() {
		const { userProfile, signOut, t } = this.props

		const isAdmin = userProfile.role === 300
		const initials =
			userProfile.firstName && userProfile.lastName
				? userProfile.firstName.charAt(0) +
				  userProfile.lastName.charAt(0)
				: 'n/a'

		return (
			<header className="o-page__header">
				<FlexContainer withPadding justifyContent="flex-end">
					<Search />
					<Tooltip
						placement="bottom-end"
						trigger="click"
						animation="shift-away"
						animateFill={false}
						theme="min-width-large"
						interactive
						onCreate={this.onCreate}
						content={
							<>
								<FlexContainer justifyContent="flex-start">
									<Avatar
										initials={userProfile.team.name.charAt(
											0
										)}
										image={userProfile.team.image}
									/>
									<Text color="dark">
										{userProfile.team.name}
										<br />
										<small>
											skara.io/{userProfile.team.slug}
										</small>
									</Text>
								</FlexContainer>
								<ButtonGroup>
									<Button
										onClick={() => {
											this.closeTippy()

											history.push({ hash: '#settings' })
										}}
										text={t('settings.settings')}
										icon={<Icon name="settings" />}
										size="small"
										layout="tertiary"
										fullWidth
									/>
									{isAdmin ? (
										<Button
											onClick={() => {
												this.closeTippy()

												history.push({
													hash: '#settings-invite',
												})
											}}
											text={t('settings.invite_user')}
											icon={<Icon name="invite-member" />}
											size="small"
											layout="tertiary"
											fullWidth
										/>
									) : null}
									<Button
										onClick={() => {
											this.closeTippy()

											history.push({
												hash: '#settings-achievements',
											})
										}}
										text={t('settings.achievements_tab')}
										icon={<Icon name="achievements" />}
										size="small"
										layout="tertiary"
										fullWidth
									/>
									{userProfile.teams.length > 1 ? (
										<>
											<hr className="o-button-group__divider" />
											<div className="o-button-group__title">
												<Text
													color="light"
													size="small"
													weight="regular"
												>
													{t('settings.switch_team')}
												</Text>
											</div>
										</>
									) : null}
									{userProfile.teams.length > 1
										? userProfile.teams.map(
												team =>
													userProfile.team.id !==
														team.id && (
														<Button
															key={team.id}
															layout="tertiary"
															fullWidth
															size="small"
															onClick={() => {
																this.closeTippy()
																history.replace(
																	`/${team.slug}`
																)
															}}
															text={team.name}
															icon={
																<Avatar
																	initials={team.name.charAt(
																		0
																	)}
																	image={
																		team.image
																	}
																/>
															}
														>
															<Avatar
																initials={team.name.charAt(
																	0
																)}
																image={
																	team.image
																}
															/>
															<span
																style={
																	userProfile
																		.team
																		.id ===
																	team.id
																		? {
																				color:
																					'red',
																		  }
																		: null
																}
															>
																{team.name}
															</span>
														</Button>
													)
										  )
										: null}
									<hr className="o-button-group__divider" />

									<Button
										onClick={() => {
											this.closeTippy()

											history.push({
												hash: '#settings-create-team',
											})
										}}
										text={t('settings.create_team')}
										icon={<Icon name="plus" />}
										size="small"
										layout="tertiary"
										fullWidth
									/>
									<Button
										onClick={signOut}
										text={t('settings.sign_out')}
										layout="tertiary"
										fullWidth
										size="small"
										icon={<Icon name="sign-out" />}
									/>
								</ButtonGroup>
							</>
						}
					>
						<Avatar
							initials={initials}
							image={userProfile.image}
							className="tippy-link"
						/>
					</Tooltip>
				</FlexContainer>
			</header>
		)
	}
}

PageHeader.propTypes = {
	signOut: PropTypes.func.isRequired,
	userProfile: PropTypes.shape().isRequired,
}

export default translate()(PageHeader)
